var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui_phone_input"},[_c('input',{ref:"phone_input",staticClass:"phone_input",class:{isValid: _vm.isValid},attrs:{"inputmode":"tel"},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }